// Lightweight socials, stored as a username (or a full website URL).
// A person can type "@name" or paste a profile link; we keep the username.
export const SOCIALS = [
  { id: "instagram", label: "Instagram", placeholder: "username" },
  { id: "x", label: "X", placeholder: "username" },
  { id: "linkedin", label: "LinkedIn", placeholder: "username" },
  { id: "website", label: "Website", placeholder: "yoursite.com" },
];

const HANDLE = /^[A-Za-z0-9._-]{1,40}$/;

export const emptySocials = () => ({ instagram: "", x: "", linkedin: "", website: "" });

export const socialsFromUser = (user) => {
  const raw = user?.socials && typeof user.socials === "object" ? user.socials : {};
  const next = emptySocials();
  SOCIALS.forEach(({ id }) => {
    next[id] = typeof raw[id] === "string" ? raw[id] : "";
  });
  return next;
};

const usernameFrom = (value) => {
  const trimmed = String(value || "").trim();
  if (!trimmed) return "";
  const withProto = /^https?:\/\//i.test(trimmed)
    ? trimmed
    : /instagram\.com|x\.com|twitter\.com|linkedin\.com/i.test(trimmed)
      ? `https://${trimmed}`
      : "";
  if (!withProto) return trimmed.replace(/^@/, "");
  try {
    const url = new URL(withProto);
    const parts = url.pathname.split("/").filter(Boolean);
    if (url.hostname.includes("linkedin.com")) {
      const inIndex = parts.indexOf("in");
      if (inIndex >= 0 && parts[inIndex + 1]) return parts[inIndex + 1];
    }
    return (parts[parts.length - 1] || "").replace(/^@/, "");
  } catch (_error) {
    return trimmed.replace(/^@/, "");
  }
};

// Returns { socials } or { error }.
export const normalizeSocials = (input) => {
  const next = emptySocials();
  for (const { id, label } of SOCIALS) {
    const raw = String(input?.[id] || "").trim();
    if (!raw) continue;
    if (id === "website") {
      const withProto = /^https?:\/\//i.test(raw) ? raw : `https://${raw}`;
      let url;
      try {
        url = new URL(withProto);
      } catch (_error) {
        return { error: "Enter a real website, like proximy.ca" };
      }
      if (url.protocol !== "http:" && url.protocol !== "https:") {
        return { error: "Website must be a normal link." };
      }
      next.website = url.toString();
      continue;
    }
    const handle = usernameFrom(raw).replace(/^@/, "").split("?")[0];
    if (!HANDLE.test(handle)) {
      return { error: `That ${label} username doesn't look right.` };
    }
    next[id] = handle;
  }
  return { socials: next };
};

export const socialLinks = (socials) => {
  const source = socials || {};
  const links = [];
  if (source.instagram) {
    links.push({ id: "instagram", label: "Instagram", href: `https://instagram.com/${source.instagram}` });
  }
  if (source.x) {
    links.push({ id: "x", label: "X", href: `https://x.com/${source.x}` });
  }
  if (source.linkedin) {
    links.push({
      id: "linkedin",
      label: "LinkedIn",
      href: `https://www.linkedin.com/in/${encodeURIComponent(source.linkedin)}`,
    });
  }
  if (source.website) {
    links.push({ id: "website", label: "Website", href: source.website });
  }
  return links;
};
